import { AuthAction, AUTH_LOGIN, AUTH_LOGIN_FAIL, AUTH_LOGIN_SUCCESS, AUTH_GET_PROFILE, AUTH_GET_PROFILE_SUCCESS, AUTH_GET_PROFILE_FAIL, AUTH_LOGOUT, AUTH_RENEW_TOKEN, RESTORE_SESSION_SUCCESS, RESTORE_SESSION_FAIL, EXPIRE_SESSION_END, SET_PENDING } from "../actions/auth.actions";

export interface AuthState {
    accessToken: string;
    profile: {
        loaded: boolean;
        loading: boolean;
        entity: any;
    };
    loggedIn: boolean;
    pending: boolean;
    expiresAt: number;
}

export const initAuthState: AuthState = {
    accessToken: null,
    profile: {
        loaded: false,
        loading: false,
        entity: null
    },
    loggedIn: false,
    pending: true,
    expiresAt: null
};

export function authReducer(state: AuthState = initAuthState, action: AuthAction): AuthState {

    switch (action.type) {
        case SET_PENDING: {
            return {
                ...state,
                pending: true,
                loggedIn: false,
                expiresAt: null
            }
        }

        case EXPIRE_SESSION_END: {
            return {
                ...state,
                pending: false, loggedIn: false
            }
        }

        case RESTORE_SESSION_FAIL: {
            return {
                ...state, pending: false,
                loggedIn: false, profile: null
            }
        }

        case RESTORE_SESSION_SUCCESS: {
            const { expiresAt, accessToken } = action.payload;
            return {
                ...state, pending: false, accessToken, expiresAt,
                profile: null, loggedIn: true
            }
        }

        case AUTH_LOGIN: {
            return {
                ...state, pending: true
            }
        }

        case AUTH_LOGIN_FAIL: {
            return {
                ...state, pending: false, loggedIn: false
            }
        }

        case AUTH_LOGIN_SUCCESS: {
            const { token, expiresAt } = action.payload
            return {
                ...state, pending: false, loggedIn: true,
                accessToken: token, expiresAt
            }
        }

        case AUTH_LOGOUT: {
            return {
                ...initAuthState, pending: false
            }
        }

        case AUTH_GET_PROFILE: {
            return {
                ...state, profile: {
                    ...state.profile, loading: true
                }
            }
        }

        case AUTH_GET_PROFILE_FAIL: {
            return {
                ...state, profile: {
                    ...state.profile, loaded: false, loading: false
                }
            }
        }

        case AUTH_GET_PROFILE_SUCCESS: {
            return {
                ...state, profile: {
                    ...state.profile, loaded: true, loading: false,
                    entity: action.payload
                }
            }
        }

        case AUTH_RENEW_TOKEN: {
            return {
                ...state, loggedIn: true, accessToken: action.payload
            }
        }
    }

    return state;
}

export const accessToken = (state: AuthState) => state.accessToken;
export const loggedIn = (state: AuthState) => state.loggedIn;
export const profileLoaded = (state: AuthState) => state.profile.loaded;
export const profile = (state: AuthState) => state.profile.entity;
export const pending = (state: AuthState) => state.pending;